interface BrandItem {
  name: string;
  code: string;
}

interface ConnectionMethodItem {
  name: string;
  code: string;
  defaultBrandCode?: string;
}

export interface FormattedListItem {
  name: string;
  value: string;
  key: string;
}

export interface FormattedConnectionMethods {
  other: FormattedListItem[];
  heidenhain: FormattedListItem[];
}

const formatItem = (item: { name: string; code: string }): FormattedListItem => ({
  name: item.name,
  value: item.code,
  key: item.code,
});

export const formatBrandList = (brands: BrandItem[]): FormattedListItem[] => [
  ...brands.map(formatItem),
  { name: 'Other', value: 'other', key: 'other' },
];

export const formatConnectionMethods = (methods: ConnectionMethodItem[]): FormattedConnectionMethods => ({
  other: methods.map(formatItem),
  heidenhain: [
    { name: 'Heidenhain Automatic', value: 'heidenhain-auto', key: 'heidenhain-auto' },
    ...methods.filter((i) => i.defaultBrandCode === 'heidenhain').map(formatItem),
  ],
});

interface BuildSavePayloadParams {
  machineId: number;
  fullName: string;
  shortName: string;
  machineBrandCode: string;
  machineControl: Record<string, unknown>;
  machineConnection: Record<string, unknown>;
  connectionMethodCode: string;
  defaultPort: number | undefined;
  allowNcFileTransfer: boolean;
  connectionMethodIsAutomatic: boolean;
}

export const buildSavePayload = ({
  machineId,
  fullName,
  shortName,
  machineBrandCode,
  machineControl,
  machineConnection,
  connectionMethodCode,
  defaultPort,
  allowNcFileTransfer,
  connectionMethodIsAutomatic,
}: BuildSavePayloadParams) => ({
  machineId,
  fullName,
  shortName,
  machineBrand: { code: machineBrandCode },
  machineControl,
  machineConnection: {
    ...machineConnection,
    connectionMethod: { code: connectionMethodCode, defaultPort },
    allowNcFileTransfer,
    connectionMethodIsAutomatic,
  },
});
